var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9634 8.33999H39.6544L39.5162 8.61631L18.5528 50.5249L18.5 50.6305V50.7486V70.5086V71.0086H19H52.2143V84.84V85.34H52.7143H66.978H67.478V84.84V71.0086H78H78.5V70.5086V56.8286V56.3286H78H67.478V8.83999V8.33999H66.978H39.9634ZM52.2143 56.3286H31.8187V54.9924L51.0781 16.5057H52.2143V56.3286Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.5021aa67258468b76c25a341655010cc.svg";
export { ForwardRef as ReactComponent };